import React, { useState, useEffect } from "react";
import { Button } from "hesus-ui-kit";
import PropTypes from "prop-types";

import AddEditTransportQuotation from "../AddEditTransportQuotation/AddEditTransportQuotation";

const Action = (props) => {
  const { data, onRefreshData } = props;
  const [showTransportQuotation, setTransportQuotationPopup] = useState(false);

  const onClick = () => {
    setTransportQuotationPopup(true);
  };

  const onClose = () => {
    setTransportQuotationPopup(false);
    onRefreshData(true);
  };

  useEffect(() => {
    onRefreshData(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Button
        styles={{
          color: "white",
          background: "#1BACE4",
          padding: "0.75rem .875rem",
          minWidth: "200px",
          border: "1px solid #1BACE4",
          "&:hover": {
            backgroundColor: "#1589b6",
          },
        }}
        id="apply-filter"
        onClick={onClick}
      >
        {data.name}
      </Button>
      {showTransportQuotation && (
        <AddEditTransportQuotation
          onClose={onClose}
          id={data.id}
          countryId={data.countryId}
        />
      )}
    </>
  );
};

Action.propTypes = {
  data: PropTypes.shape({ name: PropTypes.string, id: PropTypes.number })
    .isRequired,
  onRefreshData: PropTypes.func.isRequired,
};

export default Action;
